import React, { useState } from 'react';



export const GetCodeModal = ({ codeSnippet, handleModalData }) => {

  const [copySuccess, setCopySuccess] = useState(null);

  const handleCopyCodeSnippet = () => {

    let x = document.querySelector('.code-snippet').innerText;

    navigator.clipboard.writeText(x)
      .then(() => {

        setCopySuccess(true)

      }, () => {
        setCopySuccess(null);
      })

  }


  return (
    <div className="modal" style={{ opacity: codeSnippet && 1, transform: codeSnippet && 'scale(1)' }}>

      <div className="modal-box" style={{ transform: codeSnippet && 'scale(1) translateX(-50%)' }}>
        <header>
          <h3>Code Snippet</h3>
          <span onClick={() => {
            handleModalData(false);
            setCopySuccess(null);
          }}>&times;</span>

        </header>
        <hr />
        <div className="box-content" >

          {
            codeSnippet &&
            <div
              className="code-snippet"
              dangerouslySetInnerHTML={{ __html: codeSnippet }}
            ></div>
          }

        </div>
        <hr />
        <footer className="">

          {
            copySuccess ?
              <div className="d-flex jc-c ai-c pt-2">
                <img src="./assets/icons/greenSuccess.svg" alt="success" style={{ height: '1.5rem' }} />
                <div className="pl-2">Copied to clipboard</div>
              </div>
              :
              <div className="d-flex jc-fe ai-c">
                <button className="btn bg-success" onClick={handleCopyCodeSnippet}>Copy</button>
              </div>
          }

        </footer>
      </div>

    </div>
  )
}

const GetCode = ({ handleModalData }) => {
  return (
    <button className="btn get-code" onClick={() => handleModalData(true)}>
      <div>Get</div>
      <div>Code</div>
    </button>
  );
}

export default GetCode;